import $ from 'jquery';

// Class
class ProductCards{
    constructor($root){
        if( !$root.length ) return;

        this.$root = $root;
        this.$track = $root.find('.product-cards__track');
        this.$prevArrow = $root.find('.product-cards__arrow--prev');
        this.$nextArrow = $root.find('.product-cards__arrow--next');
        this.$dots = $root.find('.product-cards__dots');

        // Slick's own responsive "unslick" setting only fires one-way and
        // tears down its resize listener, so it can never re-init going
        // back up past the breakpoint. Drive it manually instead.
        this.mql = window.matchMedia('(min-width: 1024px)');
        this.onChange = this.onChange.bind(this);

        this.onChange(this.mql);
        this.mql.addEventListener('change', this.onChange);
    }

    onChange(e){
        if( e.matches ){
            this.enable();
        } else {
            this.disable();
        }
    }

    enable(){
        if( this.$track.hasClass('slick-initialized') ) return;

        this.$track.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: false,
            dotsClass: 'product-cards__dots-list',
            prevArrow: this.$prevArrow,
            nextArrow: this.$nextArrow,
            appendDots: this.$dots
        });
    }

    disable(){
        if( !this.$track.hasClass('slick-initialized') ) return;

        this.$track.slick('unslick');
    }
}

$( function(){
    // Maybe iterate over each of these to support multiple on a page.
    $('.product-cards').each(function(){
        new ProductCards($(this));
    });
} );
